import { render, staticRenderFns } from "./scheduleClassesPageList.vue?vue&type=template&id=3241c04c&scoped=true"
import script from "./scheduleClassesPageList.vue?vue&type=script&lang=js"
export * from "./scheduleClassesPageList.vue?vue&type=script&lang=js"
import style0 from "./scheduleClassesPageList.vue?vue&type=style&index=0&id=3241c04c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3241c04c",
  null
  
)

export default component.exports